import { Component, OnInit } from '@angular/core';
import { BrandService } from '../../../../../../services/brand.service';
import { FruHttpService } from '../../../../../../services/fru-http.service';

@Component({
    selector: 'app-product-options',
    templateUrl: './product-options.component.html',
    styleUrls: ['./product-options.component.scss'],
    standalone: false
})
export class ProductOptionsComponent implements OnInit {
  title: string;
  cards: any[] = [];
  pageVersion: string;

  constructor(
    private httpService: FruHttpService,
    private brandService: BrandService,
  ) {
    switch (this.brandService.domain) {
      case 'homeequitychoice.com':
      case 'besthomeequityloan.com':
        this.pageVersion = 'home-equity';
        break;

      default:
        break;
    }
  }
  ngOnInit(): void {
    this.httpService.getPageInfo(this.pageVersion).subscribe(x => {
      this.title = x.title;
      this.cards = x.cards;
    })
  }
}
